<script>
// Extensions
import View from "@/views/home/View";

// Mixins
import LoadSections from "@/mixins/load-sections";

export default {
  name: "Blogs",

  metaInfo: { title: "Blogs" },

  extends: View,

  mixins: [
    LoadSections([
        "all-blogs"
    ]),
  ],

  props: {
    id: {
      type: String,
      default: "blogs",
    },
  },
};
</script>
